import React, { useCallback } from 'react'
import { observer } from 'mobx-react'
import { useStores, useApiRequest } from 'admin/hooks'
import * as srv from 'admin/services'
import { Typography } from '@mui/material'
import CustomDialog from 'admin/components/dialog'

const ConfirmSmsDialog = () => {
  const { posStore, infoSectionStore, notificationStore } = useStores()
  const { selected } = infoSectionStore
  const { request: updatePOSSmsNotification, isLoading: enableSmsProcessing } = useApiRequest(
    srv.updatePOSSmsNotification,
    { blocking: true },
  )
  const { request: disablePOSSmsNotification, isLoading: disableSmsProcessing } = useApiRequest(
    srv.disablePOSSmsNotification,
    { blocking: true },
  )

  const onConfirm = useCallback(async () => {
    const isDisableSMSNotify = selected?.smsNotification
    const prestoId = selected?.id

    try {
      if (!prestoId) {
        notificationStore.setError('ID is missing.')
        return
      }
      const request = isDisableSMSNotify ? disablePOSSmsNotification : updatePOSSmsNotification
      const response = await request(prestoId)
      if (!response) return

      await posStore.reloadCustomer()
      notificationStore.setSuccess('Sms Notification is updated')
      posStore.setCloseDialog('smsNotification')
    } catch (error) {
      notificationStore.setError(error)
    }
  }, [selected])

  const handleCloseDialog = useCallback(async () => {
    posStore.setCloseDialog('smsNotification')
  }, [])

  return (
    <CustomDialog
      open={!!posStore.dialog.smsNotification}
      size="sm"
      title="Confirm SMS Notification"
      primaryActionLabel="Confirm"
      content={
        <Typography variant="body2">
          Are you sure you want to {selected?.smsNotification ? 'disable' : 'enable'} SMS notification for this customer?
        </Typography>
      }
      loading={disableSmsProcessing || enableSmsProcessing}
      onAccept={onConfirm}
      onClose={handleCloseDialog}
    />
  )
}

export default observer(ConfirmSmsDialog)
